import uploadMixin from './uploadMixin';
import actionBoxMixin from '@/components/core/mixinActionBoxStyles';
export default {
  name: 'NiotaClassicDevicesUploadForm',
  mixins: [uploadMixin, actionBoxMixin],
  props: {},
  data: function () {
    return {};
  }
};